import actions from './actions';
import { createReducer } from '../../helpers/reducer';

const initState = {
  loading: true,
};

function onGetStartAppSettingsSuccess(state, { payload }) {
  return {
    ...state,
    loading: false,
    ...payload,
  };
}

export default createReducer(initState, {
  [actions.GET_START_APP_SETTINGS_SUCCESS]: onGetStartAppSettingsSuccess,
});
